<template>
  <div class="Account">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-tabs ref="tabs" v-model="activeTab" type="card">
        <el-tab-pane label="계좌관리" name="1">
          <AccountReg
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="계좌설정" name="2">
          <AccountConfig
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { authority_level } from "@/common/mixins/authority_level";
import AccountReg from "./AccountReg";
import AccountConfig from "./AccountConfig";

export default {
  name: "Account",
  mixins: [authority_level],
  components: {AccountReg, AccountConfig},
  data() {
    return {
      title: this.$t("title.account"),
      activeTab: '1',
    }
  },
  computed: {
    has_grant_write() {
      return this.isWriteLevel('account');
    },
  },
}
</script>
